<template>
    <Head title="Manufacturers" />
    <BreezeAuthenticatedLayout>
        <template #header>
            <div class="grid grid-flow-col gap-4">
                <div>
                    <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                        Manufacturers
                    </h2>
                </div>
                <div class="text-right">
                    <admin-link :href="`/admin/manufacturers/create`" title="Create New">Create New</admin-link>
                </div>
            </div>
        </template>
        <BreadCrumbs :items="navItems"></BreadCrumbs>
        <div class="relative w-full py-12 my-6 overflow-hidden shadow">
            <form @submit.prevent="form.get('manufacturers')">
                <admin-search-form v-model="form.search"></admin-search-form>
            </form>
            <div class="px-2 md:px-6 pt-2 md:pt-4 pb-2">
                <div class="overflow-x-auto">
                    <div class="inline-block min-w-full overflow-hidden">
                        <table class="min-w-full leading-normal">
                                <thead class="uppercase text-gray-600 text-xs font-semibold bg-gray-200">
                                    <tr class="hidden lg:table-row">
                                        <th class="bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-sm text-left tracking-wider">ID</th>
                                        <th class="bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-sm text-left tracking-wider">Name</th>
                                        <th class="bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-sm text-left tracking-wider">&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody class="my-3 flex-1 lg:flex-none">
                                    <tr v-if="manufacturers.data.length"
                                        v-for="manufacturer in manufacturers.data"
                                        :key="manufacturer.id"
                                        class="mb-2 lg:mb-0 border-2 lg:border-b-2 border-grey-200 lg:border-t lg:first:border-t-0 flex p-1 md:p-3 hover:bg-gray-100 lg:table-row flex-col w-full flex-wrap">
                                        <td class="p-1 lg:p-5 lg:border-l-2 lg:border-b border-grey-200 bg-white text-sm md:text-base">
                                            <label class="mb-3 bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-sm text-left tracking-wider block lg:hidden">ID</label>
                                            {{ manufacturer.id }}
                                        </td>
                                        <td class="p-1 lg:p-5 lg:border-b border-grey-200 bg-white text-sm md:text-base">
                                            <label class="mb-3 bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-sm text-left tracking-wider block lg:hidden">Name</label>
                                            {{ manufacturer.name }}
                                        </td>
                                        <td class="px-5 py-5 lg:border-r lg:border-b border-grey-200 bg-white text-center lg:text-right text-sm md:text-base">
                                            <admin-link class="bg-grey-100 text-dark"
                                                        target="_blank"
                                                        :href="route('manufacturers.show', manufacturer)">View
                                            </admin-link>
                                            <admin-link class="bg-secondary"
                                                        :href="'/admin/manufacturers/' + manufacturer.id">Edit Models
                                            </admin-link>
                                            <admin-link :href="'/admin/manufacturers/' + manufacturer.id + '/edit'">
                                                Edit
                                            </admin-link>
                                            <admin-link type="button"
                                                        class="bg-red"
                                                        @click="showDeleteModal(manufacturer.id)">Delete
                                            </admin-link>
                                            <admin-delete-modal v-if="deleteModalIdToShow === manufacturer.id"
                                                                :msg="modalMessage"
                                                                :type="modalType"
                                                                @toggle-delete-modal="hideDeleteModal()"
                                                                @delete-item="deleteItem(manufacturer.id)"></admin-delete-modal>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        <admin-pagination class="my-6" :links="manufacturers.links" />
                    </div>
                </div>
            </div>
        </div>
        <ToTopLink>To Top</ToTopLink>
    </BreezeAuthenticatedLayout>
</template>

<script>
    import BreezeAuthenticatedLayout from '@/Layouts/Admin/Authenticated.vue';
    import {Head, useForm} from '@inertiajs/inertia-vue3';
    import { Link } from '@inertiajs/inertia-vue3';
    import AdminLink from "@/Components/Admin/AdminLink";
    import AdminDeleteModal from "@/Components/Admin/AdminDeleteModal";
    import AdminSearchForm from "@/Components/Admin/Forms/AdminSearchForm";
    import AdminPagination from "@/Components/Admin/AdminPagination";
    import BreadCrumbs from "@/Components/Admin/BreadCrumbs";
    import ToTopLink from "@/Components/Admin/ToTopLink";
    export default {
        components:
            {
                BreadCrumbs,
                AdminDeleteModal,
                AdminLink,
                AdminSearchForm,
                AdminPagination,
                Link,
                Head,
                BreezeAuthenticatedLayout,
                ToTopLink
            },
        data()
        {
            return {
                navItems: [
                    { title: 'Manufacturers', path: '/admin/manufacturers' },
                ],
                deleteModalIdToShow: false,
                modalMessage: 'Are you sure you want to delete this manufacturer?',
                modalType: 'Manufacturer',
                form: useForm({
                    search: this.term
                })
            }
        },
        props: {
            manufacturers: Object,
            term: String
        },
        methods: {
            showDeleteModal(id)
            {
                this.deleteModalIdToShow = id;
            },
            hideDeleteModal()
            {
                this.deleteModalIdToShow = false;
            },
            deleteItem(id)
            {
                this.$inertia.delete('/admin/manufacturers/'+id);
            }
        }
    }
</script>
